import React from "react"
import { isNull } from 'lodash';
import FeaturesBox from '../FeaturesBox/FeaturesBox';
import "./ComunicadosOficiales.css"

const ROOT = process.env.REACT_APP_CMS_STATIC;

function ComunicadosOficiales({ listaComunicados = [] }) {

    return (
        <div className="comunicados-oficiales-container">
            <p className="comunicados-oficiales-titulo">Comunicados <b>oficiales</b></p>
            <div className="comunicados-oficiales-lista-container">
                {!isNull(listaComunicados) && listaComunicados.map((item, index) => (
                    <FeaturesBox
                        key={index}
                        titulo={item?.titulo}
                        imagenUrl={ROOT + item?.icono?.urls[0]}
                        featUrl={item?.enlaceBoton}
                        titlePos="middle"
                        descripcion={item?.descripcion?.html}
                        showMoreInfoButton={true}
                        moreInfoButtonText={item?.textoBoton}
                    />
                ))}
            </div>
        </div>

    )
}

export default ComunicadosOficiales
